import request from '../utils/request'

// ========== 认证 ==========
export function login(data) {
  return request({ url: '/auth/login', method: 'post', data })
}
export function getInfo() {
  return request({ url: '/auth/info', method: 'get' })
}
export function logout() {
  return request({ url: '/auth/logout', method: 'post' })
}

// ========== 首页统计 ==========
export function getDashboardStats() {
  return request({ url: '/dashboard/stats', method: 'get' })
}

// ========== 用户管理 ==========
export function getUsers(params) {
  return request({ url: '/users', method: 'get', params })
}
export function getUserDetail(id) {
  return request({ url: `/users/${id}`, method: 'get' })
}
export function disableUser(id) {
  return request({ url: `/users/${id}/disable`, method: 'put' })
}
export function enableUser(id) {
  return request({ url: `/users/${id}/enable`, method: 'put' })
}
export function limitUserPost(id, data) {
  return request({ url: `/users/${id}/limit-post`, method: 'put', data })
}
export function limitUserChat(id, data) {
  return request({ url: `/users/${id}/limit-chat`, method: 'put', data })
}

// ========== 认证审核 ==========
export function getCertifications(params) {
  return request({ url: '/certifications', method: 'get', params })
}
export function getCertificationDetail(id) {
  return request({ url: `/certifications/${id}`, method: 'get' })
}
export function approveCertification(id, data) {
  return request({ url: `/certifications/${id}/approve`, method: 'put', data })
}
export function rejectCertification(id, data) {
  return request({ url: `/certifications/${id}/reject`, method: 'put', data })
}
export function showQualification(id) {
  return request({ url: `/qualifications/${id}/show`, method: 'put' })
}
export function hideQualification(id) {
  return request({ url: `/qualifications/${id}/hide`, method: 'put' })
}

// ========== 城市管理 ==========
export function getCities(params) {
  return request({ url: '/cities', method: 'get', params })
}
export function addCity(data) {
  return request({ url: '/cities', method: 'post', data })
}
export function updateCity(id, data) {
  return request({ url: `/cities/${id}`, method: 'put', data })
}
export function deleteCity(id) {
  return request({ url: `/cities/${id}`, method: 'delete' })
}

// ========== 分类管理 ==========
export function getCategories(params) {
  return request({ url: '/categories', method: 'get', params })
}
export function addCategory(data) {
  return request({ url: '/categories', method: 'post', data })
}
export function updateCategory(id, data) {
  return request({ url: `/categories/${id}`, method: 'put', data })
}
export function deleteCategory(id) {
  return request({ url: `/categories/${id}`, method: 'delete' })
}
export function getCategoryFields(params) {
  return request({ url: '/category-fields', method: 'get', params })
}
export function addCategoryField(data) {
  return request({ url: '/category-fields', method: 'post', data })
}
export function updateCategoryField(id, data) {
  return request({ url: `/category-fields/${id}`, method: 'put', data })
}
export function deleteCategoryField(id) {
  return request({ url: `/category-fields/${id}`, method: 'delete' })
}

// ========== 帖子管理 ==========
export function getPosts(params) {
  return request({ url: '/posts', method: 'get', params })
}
export function getPostDetail(id) {
  return request({ url: `/posts/${id}`, method: 'get' })
}
export function offlinePost(id) {
  return request({ url: `/posts/${id}/offline`, method: 'put' })
}
export function onlinePost(id) {
  return request({ url: `/posts/${id}/online`, method: 'put' })
}
export function deletePost(id) {
  return request({ url: `/posts/${id}`, method: 'delete' })
}
export function setPostTop(id) {
  return request({ url: `/posts/${id}/top`, method: 'put' })
}
export function setPostRecommend(id) {
  return request({ url: `/posts/${id}/recommend`, method: 'put' })
}

// ========== 收入统计 ==========
export function getRevenueRecords(params) {
  return request({ url: '/revenue/records', method: 'get', params })
}
export function getRevenueSummary(params) {
  return request({ url: '/revenue/summary', method: 'get', params })
}

// ========== 违规词库 ==========
export function getViolationWords(params) {
  return request({ url: '/violation-words', method: 'get', params })
}
export function addViolationWord(data) {
  return request({ url: '/violation-words', method: 'post', data })
}
export function updateViolationWord(id, data) {
  return request({ url: `/violation-words/${id}`, method: 'put', data })
}
export function deleteViolationWord(id) {
  return request({ url: `/violation-words/${id}`, method: 'delete' })
}
export function importViolationWords(data) {
  return request({ url: '/violation-words/import', method: 'post', data })
}
export function getHitRecords(params) {
  return request({ url: '/violation-words/hit-records', method: 'get', params })
}

// ========== AI管理 ==========
export function getAiAuditRecords(params) {
  return request({ url: '/ai/audit-records', method: 'get', params })
}
export function getAiCallLogs(params) {
  return request({ url: '/ai/call-logs', method: 'get', params })
}
export function getAiConfig() {
  return request({ url: '/ai/config', method: 'get' })
}
export function updateAiConfig(data) {
  return request({ url: '/ai/config', method: 'put', data })
}

// ========== 收费规则 ==========
export function getFeeRules(params) {
  return request({ url: '/fee-rules', method: 'get', params })
}
export function addFeeRule(data) {
  return request({ url: '/fee-rules', method: 'post', data })
}
export function updateFeeRule(id, data) {
  return request({ url: `/fee-rules/${id}`, method: 'put', data })
}
export function deleteFeeRule(id) {
  return request({ url: `/fee-rules/${id}`, method: 'delete' })
}

// ========== 聊天管理 ==========
export function getChatSessions(params) {
  return request({ url: '/chats/sessions', method: 'get', params })
}
export function getChatMessages(sessionId, params) {
  return request({ url: `/chats/sessions/${sessionId}/messages`, method: 'get', params })
}
export function deleteChatMessage(id) {
  return request({ url: `/chats/messages/${id}`, method: 'delete' })
}

// ========== 举报管理 ==========
export function getReports(params) {
  return request({ url: '/reports', method: 'get', params })
}
export function getReportDetail(id) {
  return request({ url: `/reports/${id}`, method: 'get' })
}
export function processReport(id, data) {
  return request({ url: `/reports/${id}/process`, method: 'put', data })
}

// ========== 广告管理 ==========
export function getBanners(params) {
  return request({ url: '/banners', method: 'get', params })
}
export function addBanner(data) {
  return request({ url: '/banners', method: 'post', data })
}
export function updateBanner(id, data) {
  return request({ url: `/banners/${id}`, method: 'put', data })
}
export function deleteBanner(id) {
  return request({ url: `/banners/${id}`, method: 'delete' })
}

// ========== 文件上传 ==========
export function uploadFile(file, folder = 'banner') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('folder', folder)
  return request({ url: '/files/upload', method: 'post', data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
}

// ========== 系统配置 ==========
export function getSystemConfigs(params) {
  return request({ url: '/configs', method: 'get', params })
}
export function updateSystemConfig(id, data) {
  return request({ url: `/configs/${id}`, method: 'put', data })
}
export function saveSkillTagOptions(data) {
  return request({ url: '/skill-tag-options', method: 'put', data })
}
export function getHotKeywords(params) {
  return request({ url: '/hot-keywords', method: 'get', params })
}
export function addHotKeyword(data) {
  return request({ url: '/hot-keywords', method: 'post', data })
}
export function updateHotKeyword(id, data) {
  return request({ url: `/hot-keywords/${id}`, method: 'put', data })
}
export function deleteHotKeyword(id) {
  return request({ url: `/hot-keywords/${id}`, method: 'delete' })
}
